// Globals
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

// Models
import { ICompositionChangeLog, ICompositionProductDiff } from '@/models/orders.model';

// Components
import AdditionalInfoContentBlock from '../AdditionalInfoContentBlock/AdditionalInfoContentBlock';
import { StyledWrapper, StyledTitle, StyledContent } from '../StatusHistoryBlock/StatusHistoryBlockStyles';
import { StyledLogDate, StyledLogFields, StyledLogsList, StyledProductsList } from './CompositionHistoryBlockStyles';

interface CompositionHistoryBlockProps {
  logs?: ICompositionChangeLog[];
}

const formatProductDiffLine = (item: ICompositionProductDiff): string => {
  const label = item.sku || item.product_id;

  return `${label}: ${item.old_qty} → ${item.new_qty}`;
};

const CompositionHistoryBlock = ({ logs = [] }: CompositionHistoryBlockProps) => {
  const { t } = useTranslation(['orders']);

  return (
    <StyledWrapper>
      <StyledTitle>{t('orders_composition_history_title')}</StyledTitle>
      {logs.length === 0 ? (
        <StyledContent>{t('orders_composition_history_empty')}</StyledContent>
      ) : (
        <StyledLogsList>
          {logs.map((log) => (
            <StyledLogFields key={log.id}>
              <StyledLogDate>{dayjs(log.created_at).format('DD.MM.YYYY HH:mm')}</StyledLogDate>
              <AdditionalInfoContentBlock
                label={t('orders_composition_history_admin')}
                value={log.admin?.full_name ?? '—'}
              />
              <AdditionalInfoContentBlock label={t('orders_composition_history_reason')} value={log.reason} />
              <AdditionalInfoContentBlock
                label={t('orders_composition_history_diff')}
                value={`${log.diff} ₴ (${log.old_total} ₴ → ${log.new_total} ₴)`}
              />
              {log.products_diff?.length > 0 && (
                <AdditionalInfoContentBlock
                  label={t('orders_composition_history_products')}
                  value={
                    <StyledProductsList>
                      {log.products_diff.map((item) => (
                        <div key={`${item.product_id}-${item.old_qty}-${item.new_qty}`}>
                          {formatProductDiffLine(item)}
                        </div>
                      ))}
                    </StyledProductsList>
                  }
                />
              )}
            </StyledLogFields>
          ))}
        </StyledLogsList>
      )}
    </StyledWrapper>
  );
};

export default CompositionHistoryBlock;
